// Assessment responses are stored in two formats over the lifetime of a
// question: legacy plain values and the newer { value, notes } objects.
// These helpers unwrap to the underlying answer so progress counters,
// scorers, and any other consumer can treat both formats uniformly.

export function unwrapResponseValue(response) {
  if (response && typeof response === 'object' && !Array.isArray(response)) {
    return response.value
  }
  return response
}

export function hasResponseValue(response) {
  const value = unwrapResponseValue(response)
  if (value === undefined || value === null || value === '') return false
  if (Array.isArray(value) && value.length === 0) return false
  return true
}
